import SiteHeader from "./components/SiteHeader";
import HeroSection from "./components/HeroSection";
import NewsFlashRail from "./components/NewsFlashRail";
import TimelineSection from "./components/TimelineSection";
import DeepDiveSection from "./components/DeepDiveSection";
import ArchiveSection from "./components/ArchiveSection";
import BackgroundSection from "./components/BackgroundSection";
import TrendBoard from "./components/TrendBoard";
import EntryBand from "./components/EntryBand";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body text-foreground-950">
      <SiteHeader />
      <main>
        <HeroSection />
        <NewsFlashRail />
        <TimelineSection />
        <DeepDiveSection />
        <ArchiveSection />
        <BackgroundSection />
        <TrendBoard />
        <EntryBand />
      </main>
      <SiteFooter />
    </div>
  );
}